
import qs from 'qs'

const fields = [
]

export const queryTalkEntryThumbnails = (options: QueryManyOptions) => {
  const sortKey = strapiGetI18nSortKey(options?.locale, 'titles.i18n_string')

  const query = qs.stringify(
    {
      publicationState: options?.publicationState || 'live',
      sort: options?.sort || ['date:desc', `${sortKey}:asc`],
      pagination: {
        page: options?.page || 1,
        pageSize: options?.pageSize || 10,
      },
      fields,
      populate: {
        ...queryFragmentCollectionTypeDefault,
        images: true,
        subtitles: true
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `talk-entries?${query}`
}
